import * as BufferLayout from "@solana/buffer-layout";
import { Field } from "./Field";
export class BlobField extends Field {
    constructor(span, property) {
        super(span, property);
        this.delegate = new BufferLayout.Blob(span, property);
    }
    decode(b, offset) {
        const blob = this.delegate.decode(b, offset);
        return this.fromBuffer(blob);
    }
}
//# sourceMappingURL=BlobField.js.map